module.exports = __webpack_public_path__ + "images/compliance/images/GovDocs-File-Icon.png";